import React, { Fragment, useEffect, useState } from 'react'
import userPic from "./../../Images/user2.png"
import { useDispatch, useSelector } from 'react-redux';
import { getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { useParams } from 'react-router-dom';
import { getAllMessagesAPI, getMessages, getNextMessageAPI, getNextMessageToken, sendMessageNewAPI, sendTextMessageAPI, stopNext } from '../../RTK/Slice/Messages/MessageSlice';
import { STATUS } from '../../Constants';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCircleStop, faClockRotateLeft, faEnvelope, faFilter, faMagnifyingGlass, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Backdrop, Fade, Modal, Skeleton } from '@mui/material';
import { toast } from 'react-toastify';
import {motion} from "motion/react"
import { useTranslation } from 'react-i18next';

const AllMessagesComponent = () => {

    // For store start data and end date
    const [startData , setStartDate] = useState(null);

    const [endData , setEndDate] = useState(null);

    const handleStartDate = (time)=>{
        console.log(time.target.value);
        setStartDate(time.target.value)
    }

    const handleEndDate = (time)=>{
        console.log(time.target.value);
        setEndDate(time.target.value);
    }

    // For Control Show filter Modal
    const [showFilterModal , setShowFilterModal] = useState(false);


    // For Store Seach Value
    const [search , setSearch] = useState('') ;

    // For Set status of next group
    const [statusNext , setStatusNext] = useState('') ; // stop  || con

    // For Time Next
    const [timerNext , setTimeNext] = useState(0) ; 

    // For Stop Get Next
    const stopNextHandler = ()=>{
        // dispatch(stopNext()) ;
        if(statusNext === "stop"){
            setStatusNext('con') ;
            
        }else{
            setStatusNext('stop')
            dispatch(stopNext()) ; 
        }

    }

    // For Store Message (Text , Photo)
    const [messageText , setMessageText] = useState(``) ; 

    // For store photo url
    const [photoUrl , setPhotoUrl] = useState('') ; 

    // For Access Link Template
    const [link , setLink] = useState('') ;

    // For Acess Title
    const [title , setTitle] = useState('');

    // For Access Button Title
    const [buttonTitle , setButtonTitle] = useState('') ; 

    
    // For Control Reply Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // For Control Show Time Mneu 
    const [showTime , setShowTime] = useState(false) ; 

    // For Store Choose Time
    const [timer , setTime] = useState("") ; 

    // For Get Page ID and Page Token
    const {pageId , pageToken } = useParams() ;

    // For Make Translation
    // const {t} = useTranslation() ;

    // For Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        overflowY :"scroll" ,
        p: 4,
        };
    

    const [selectedMessages , setSelectedMessages ] = useState([]) ;

    // For Check Select All
    const [selectAll , setSelectAll ] = useState(false) ;

    // For Get token 
    const token = useSelector(getToken) ; 

    // For Dispatch Action
    const dispatch = useDispatch() ;

    // For Select Single Chat
    const selectSingleChat = (e)=>{

        let isSelectd = e.target.checked ;
        let value = e.target.value ; 

        if(isSelectd){
            setSelectedMessages([...selectedMessages , value]) ;

        }else{
            setSelectedMessages(prev =>selectedMessages.filter((id)=>id !== value)) ;
        }

    }

    //for open filter modal
    const showFilterModalHandler = ()=>{
        setShowFilterModal(true);
    }

    // For Close Filter Modal
    const hideFilterModalHandler = ()=>{
        setShowFilterModal(false);
    }



    // For Reply Message Handler
    const replyMessageHandler = ()=>
        {
        if(timer && (messageText || (photoUrl && title && link)) ){
            let time = 0;
            for(let i = 0 ; i < selectedMessages.length ;i++) {
                setTimeout(()=>{
                    // dispatch(sendTextMessageAPI({token , userId : selectedMessages[i] , numMsg : i , imageUrl :photoUrl  , message : messageText ,pageToken })) ; 
                    dispatch(sendMessageNewAPI({token , recipientId : selectedMessages[i] , numMsg : i , imageUrl :photoUrl , url :link , title,pageToken ,content_msg :messageText , buttonTitle }))

                } , time)
                time += getRandomBetween1And2Minutes(timer) ; 
            }
            handleClose()
            const id = toast.loading("Sending Messages...")
            setTimeout(()=>{
                toast.update(id, {
                    render: "Operation successful!",
                    type: "success",
                    isLoading: false, // Stop the loading spinner
                    autoClose: 100, // Automatically close after 3 seconds
                    });
                    dispatch(getAllMessagesAPI({token , pageToken , pageId}))
                } , time)
            setMessageText("")
        }
        else{
            toast.info("Please Write Messages")
        }
        
    }

    // For Select All Chat 
    const selectAllChats = (e)=>{
        const isSelected = e.target.checked ; 
        if(isSelected){
            setSelectAll(true)
            setSelectedMessages(
                allMessages
                .filter((item)=> search ==='' || item.participants?.data[0]?.name.toLowerCase().includes(search))
                .filter((item)=>{
                    const date = new Date(item.updated_time) ; 
                    
                    
                    if(startData  && endData ){
                        const start = new Date(startData);
                        
                        const end = new Date(endData);
                        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
                    }
                    return item
                })
                .map((item)=>item?.participants?.data[0]?.id) ) ;
        }else{
            setSelectAll(false)
            setSelectedMessages([])
        }
    }

    // For Access Next Token if found
    const hasNext = useSelector(getNextMessageToken) ; 

    // For Get The Next Message Handler 
    const getNextMessageHandler = ()=>{
        if(hasNext) { 
            dispatch(getNextMessageAPI({pageId , token , pageToken , nextMessageToken: hasNext}))
        }
    }

    // For Translate Page 
    const {t} = useTranslation() ;

    
    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
        // Convert minutes to milliseconds
        const min = args.t1 * 1000; // 1 minute in milliseconds
        const max = args.t2  * 1000; // 2 minutes in milliseconds
        
        // Generate random number between min and max
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // For Render Reply Modal
    const renderMessageModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={open}>
                <div className='k-modal my-font send-message-model' style={style}>

                    <div className='head'>
                        <div className='left'>
                            <h3>{t('writeMessage')}</h3>
                            <p>{t('messagePopInfo')}</p>
                        </div>
                        <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('messageContent')} </label>
                            <textarea value={messageText} onChange={(e)=>setMessageText(e.target.value)}  autoFocus placeholder={t('writeMessage')} className='message-field' id='message-input'></textarea>
                        </div>

                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('messageTitle')}</label>
                            <textarea value={title} style={{height : "40px"}} onChange={(e)=>setTitle(e.target.value)}  autoFocus placeholder={t('writeMessageTitle')} className='message-field' id='message-input'></textarea>
                        </div>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('buttonTitle')}</label>
                            <textarea value={buttonTitle} style={{height : "40px"}} onChange={(e)=>setButtonTitle(e.target.value)}  autoFocus placeholder={t('writeButton')} className='message-field' id='message-input'></textarea>
                        </div>

                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('PhotoUrl')}</label>
                            <textarea value={photoUrl} style={{height : "40px"}} onChange={(e)=>setPhotoUrl(e.target.value)}  autoFocus placeholder={t('url')} className='message-field' id='message-input'></textarea>
                        </div>

                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('websiteLink')}</label>
                            <textarea value={link} style={{height : "40px"}} onChange={(e)=>setLink(e.target.value)}  autoFocus placeholder={t('url')} className='message-field' id='message-input'></textarea>
                        </div>

                        {/*
                            <div className='choose-image'>
                                <input onChange={(e)=>setPhotoMessage(e.target.files[0])} type="file" />
                                <div className='center'>
                                    <img src={photoPic} alt='phots' />
                                    <p className='title'>Add Photos/Videos</p>
                                    <p className='des'> {photoMessage === null ? `or drag and drop` : photoMessage} </p>
                                </div>
                            </div>
                            
                        */}
                        

                        <div className='choose-time' onClick={()=>setShowTime(!showTime)}>
                            <p>{timer ? `Between ${timer.t1} sec and ${timer.t2} sec`: "Time Between Replys"}</p>
                            <FontAwesomeIcon icon={faChevronDown} />
                            
                            <ul className={`list-items ${showTime ? "list-items-show": "" }`}>
                            <li onClick={()=>setTime({t1 : 1 , t2 : 2})} >Between 1 sec and 2 sec</li>
                                <li onClick={()=>setTime({t1 : 3 , t2 : 5})} >Between 3 sec and 5 sec</li>
                                <li onClick={()=>setTime({t1 : 4 , t2 : 6})} >Between 4 sec and 6 sec</li>
                                <li onClick={()=>setTime({t1 : 7 , t2 : 8})} >Between 7 sec and 8 sec</li>
                                <li onClick={()=>setTime({t1 : 9 , t2 : 10})} >Between 9 sec and 10 sec</li>
                                <li onClick={()=>setTime({t1 : 10 , t2 : 15})} >Between 10 sec and 15 sec</li>
                                <li onClick={()=>setTime({t1 : 18 , t2 : 48})} >Between 15 sec and 20 sec</li>
                                <li onClick={()=>setTime({t1 : 30 , t2 : 60})} >Between 30 sec and 60 sec</li>
                                <li onClick={()=>setTime({t1 : 60 , t2 : 120})} >Between 1 min and 2 min</li>
                                <li onClick={()=>setTime({t1 : 180 , t2 : 240})} >Between 3 min and 4 min</li>
                                <li onClick={()=>setTime({t1 : 300 , t2 : 360})} >Between 5 min and 6 min</li>
                                <li onClick={()=>setTime({t1 : 420 , t2 : 480})} >Between 7 min and 8 min</li>
                                <li onClick={()=>setTime({t1 : 540 , t2 : 600})} >Between 9 min and 10 min (Recommend for lage Messages) </li>
                                <li onClick={()=>setTime({t1 : 600 , t2 : 900})} >Between 10 min and 15 min </li>
                            </ul>
                            
                            
                        </div>

                    </div>

                    <div className='btn'>
                        <button onClick={replyMessageHandler} >{t('send')}</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }

    // For Render Message Modal
    const renderFilterModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={showFilterModal}
            onClose={hideFilterModalHandler}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={showFilterModal}>
                <div className='filter-container my-font'>
                    <div className='head'>
                        <h2>Filter</h2>
                        <button onClick={hideFilterModalHandler} className='close-btn' type='button'>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                    <form onSubmit={hideFilterModalHandler} className='body'>
                        <div className='inputs-body'>
                            <div className='input-con'>
                                <p>Start Date</p>
                                <div className='input-date'>
                                    <input value={startData} type="datetime-local" onChange={handleStartDate}/>
                                </div>
                            </div>
                            <div className='input-con'>
                                <p>End End</p>
                                <div className='input-date'>
                                    <input value={endData} type="datetime-local" onChange={handleEndDate}/>
                                </div>
                            </div>
                        </div>
                        <div className='apply-btn'>
                            <button className='btn-hover' onClick={(e)=>{e.preventDefault();hideFilterModalHandler() }} >Apply</button>
                        </div>
                    </form>
                </div>
                
                
            </Fade>
        </Modal>
        )
    }

    const handleRestFilter = ()=>{
        setStartDate(null) ; 
        setEndDate(null)
    }

    // For Get All Messages
    useEffect(()=>{
        dispatch(getAllMessagesAPI({token , pageToken , pageId}))
    } , []) ; 

    // For Acccess Messages 
    const {allMessages , status} = useSelector(getMessages) ; 

    // For Get The Next Default
    useEffect(()=>{
        if(hasNext && statusNext !== 'stop'){
            setTimeout(()=>{
                setTimeNext(  getRandomBetween1And2Minutes({t1 : 7, t2 :11}));
                dispatch(getNextMessageAPI({pageId , token , pageToken , nextMessageToken: hasNext}))
            } , timerNext)
            // setTimeNext(prev => prev + getRandomBetween1And2Minutes({t1 : 2, t2 : 5}))
        } 
        
    } , [hasNext , statusNext ])


  return (
    <div className='all-message-cards'>

        {renderMessageModal()}
        {renderFilterModal()}

        <h3 style={{margin: "5px 0px"}}>{t('totalMessagesExtracted')}  {allMessages.length}</h3>

        <div className='search-tools' style={{flexWrap : "wrap"}}>
            <div className='sea-con' style={{display : "flex" , alignItems :"center"}}>
                <div className='search-bar'>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    <input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder={t('search')}  autoFocus/>
                </div>
                <button onClick={stopNextHandler} style={{margin :"0px 7px" }} className='stop-btn'>{statusNext === 'stop' ? <FontAwesomeIcon icon={faPlay} /> : <FontAwesomeIcon icon={faCircleStop} />} {statusNext === 'stop' ? t("continue") : t('stop')}</button>
                {/*<input type="datetime-local" onChange={handleStartDate}/>
                <input type="datetime-local" onChange={handleEndDate}/>*/}
                <button type='button' onClick={showFilterModalHandler} className='filter-btn btn-hover'>
                    <FontAwesomeIcon icon={faFilter} />
                </button>
                <button type='button' title='Rest button' className='filter-btn btn-hover' onClick={handleRestFilter}>
                    <FontAwesomeIcon icon={faClockRotateLeft} />
                </button>
            </div>
            
            <button className='btn-send' onClick={handleOpen}><FontAwesomeIcon icon={faEnvelope} /> {t('sendMessage')}  {selectedMessages.length !== 0 ?`(${selectedMessages.length})` : ""}</button>
        </div>
        <div className='message-head'>
            <div className='cell first-cell'><input onChange={selectAllChats} checked={selectAll} type="checkbox" /></div>
            <div className='cell'>{t("profilePic")}</div>
            <div className='cell'>{t('name')}</div>
            <div className='cell'>{t("time")}</div>
            <div className='cell'>{t("message")}</div>
        </div>

        <div className='body'>
            {
                allMessages?.filter((item)=> search ==='' ? item : item.participants?.data[0]?.name.toLowerCase().includes(search))
                .filter((item)=>{
                    const date = new Date(item.updated_time) ; 
                    
                    
                    if(startData  && endData ){
                        const start = new Date(startData);
                        
                        const end = new Date(endData);
                        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
                    }
                    return item
                })
                .map((item , idx)=>{
                    return(
                    <motion.div 
                    initial={{
                        opacity: 0 ,
                        translateX : -60
                    }}
                    whileInView={{
                        opacity : 1 , 
                        translateX : 0
                    }}
                    key={idx} className='message-body'>
                        <div className='cell first-cell'><input value={item?.participants?.data[0]?.id} checked={selectedMessages.includes(item?.participants?.data[0]?.id)} onChange={selectSingleChat}  type="checkbox" /></div>
                        <div className='cell'><img loading='lazy' src={userPic} alt='user' /></div>
                        <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.participants?.data[0]?.name}> {item?.participants?.data[0]?.name.length > 20 ?`${item?.participants?.data[0]?.name.slice(0 , 20)}...` : item?.participants?.data[0]?.name } </div>
                        <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.updated_time?.slice(0 , 10)}>{item?.updated_time?.slice(0 , 10)} at {item?.updated_time?.slice(11 , 19)}</div>
                        <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.messages?.data[0]?.message}>{item?.messages?.data[0]?.message.length > 30 ?`${item?.messages?.data[0]?.message.slice(0 , 50)}...` : item?.messages?.data[0]?.message }</div>
                    </motion.div>
                )}) 
                
            }
            {allMessages.length ===0  && status !== STATUS.LOADDING ? (<h2>{t("noMessage")}</h2>) :""}
            {
                status === STATUS.LOADDING ? (
                    <Fragment>
                        <div  className='message-body'>
                            <div className='cell'> <Skeleton width={125} height={13} /> </div>
                            <div className='cell'><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}   > <Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                        </div>
                        <div  className='message-body'>
                            <div className='cell'> <Skeleton width={125} height={13} /> </div>
                            <div className='cell'><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}   > <Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                        </div>
                        <div  className='message-body'>
                            <div className='cell'> <Skeleton width={125} height={13} /> </div>
                            <div className='cell'><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}   > <Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                        </div>
                        <div  className='message-body'>
                            <div className='cell'> <Skeleton width={125} height={13} /> </div>
                            <div className='cell'><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}   > <Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                            <div className='cell' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  ><Skeleton width={125} height={13} /></div>
                        </div>
                    </Fragment>
                )
                :
                ""
            }

            {/* For Pagination Next and Before */}
            
             {/*<div className="main-pagination">
                <div className="pagination-btn">
                </div>
                <div className="pagination-btn">
                    {hasNext ? (<button className="btn-pag" onClick={getNextMessageHandler} >Next</button>) : ""}
                    
                </div>
            </div>*/}

            
            <Tooltip id="my-tooltip" />

            
        </div>

    </div>
        
  )
}

export default AllMessagesComponent
